module.exports = __webpack_public_path__ + "static/media/mountain11.a2ae54b0.jpg";